export default {
  list: { lazy: () => import('./Countries'), component: 'CountryList' },
}
